<template>
  <div class="smart-door">
    <dl class="top">
      <LazyLoading>
        <dt class="goUp">
          <h1>智能门禁</h1>
          <!-- <NovoImg  :src="lineUrl" :isLazy="true"/> -->
          <img :src="lineUrl">
          <ul>
            <li>创新智能的产品体验，</li>
            <li>多种开门方式，</li>
            <li>更方便，更高效。</li>
          </ul>
          <div class="btn">
            <div @click="downClick">下载产品手册</div>
          </div>
        </dt>
      </LazyLoading>
      <dd>
        <img :src="deviceUrl">
      </dd>
    </dl>
    <div class="footer">
      <div class="left part">
        <NovoImg :width="210" :height="210" :src="cardUrl" :isLazy="true"/>

        <!-- <img :src="cardUrl"> -->
        <div style="height:150px;margin-top:30px;">
          <h1>刷卡开门</h1>
          <p>只需要使用员工卡轻触读卡区，开门速度快达500ms，进出无需等待。</p>
        </div>
      </div>
      <div class="right part">
        <!-- <img :src="scanUrl"> -->
         <NovoImg :width="210" :height="210" :src="scanUrl" :isLazy="true"/>
        <div style="height:150px;margin-top:30px;">
          <h1>扫码开门</h1>
          <p>系统运用二维码、互联网等技术，用户访客使用“软钥匙”扫码即可开门。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downFile, onceScollHandle } from "utils";
// import { onceScollHandle } from "common/js/utils";
import deviceUrl from "common/image/home/smart-door/device.png";
import lineUrl from "common/image/home/smart-door/line.png";
import scanUrl from "common/image/home/smart-door/swipe.png";
import cardUrl from "common/image/home/smart-door/card.png";
import { LazyLoading,NovoImg } from "novo-ui";
export default {
  name: "SmartDoor",
  components: {
    LazyLoading,
    NovoImg
  },
  data() {
    return {
      deviceUrl,
      lineUrl,
      scanUrl,
      cardUrl
    };
  },
  mounted() {},
  methods: {
    downClick() {
      downFile("/static/other/1.pdf", "NOVOBIT智能门禁宣传册.pdf");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.smart-door {
  // background: red;
  height: 1165px;
  padding-top: 80px;
  &:after {
    content: "";
    display: block;
    margin-top: 38px;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(-135deg, #4b9df0 0%, #5fcfff 100%);
    border-radius: 4px;
  }
  img {
    width: 30px;
    height: 8px;
    margin: 15px 0 16px 0;
  }
  ul {
    li {
      font-size: 18px;
      color: #000000;
      line-height: 36px;
    }
  }
  .top {
    height: 726px;
    width: 924px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    dt {
      width: 180px;
      padding-top: 130px;
      h1 {
        font-family: DFPKingGothicGB-Regular;
        font-size: 24px;
        color: #000000;
        line-height: 36px;
        font-weight:bold;
      }
    }
    .btn {
      margin-top: 65px;
      width: 160px;
      height: 44px;

      background-image: linear-gradient(-135deg, #7ce1ff 0%, #3ca9ff 100%);
      border-radius: 22px;
      padding: 1px;
      div {
        width: 100%;
        height: 100%;
        line-height: 43px;
        text-align: center;
        border-radius: 22px;
        background: #fff;
        font-family: DFPKingGothicGB-Regular;
        font-size: 18px;
        cursor: pointer;
        display: block;
        color: #3ca9ff;
      }
    }
  }
  dd {
    img {
      width: 586px;
      height: 726px;
    }
  }
}
.footer {
  margin: 0 auto;
  margin-top: 80px;
  width: 1060px;
  display: flex;
  justify-content: space-between;
  .part {
    width: 508px;
    display: flex;
    justify-content: space-between;
    .img {
      width: 210px;
      height: 210px;
    }
    h1 {
      font-family: DFPKingGothicGB-Regular;
      font-size: 24px;
      color: #000000;
      width: 262px;
      font-weight: 400;
      margin-bottom: 9px;
       font-weight:bold;
    }
    p {
      width: 262px;
      font-family: DFPKingGothicGB-Light;
      font-size: 18px;
      color: #000000;
      line-height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/smart-door/index.vue